import { NamedGroopitFilterDisplayDTO } from "groopit-js/client";

export interface SavedFiltersAddAction {
  type: "add";
  filter: NamedGroopitFilterDisplayDTO;
}
export const SavedFiltersAddActionType = "add";
export const createSavedFiltersAddAction = (
  filter: NamedGroopitFilterDisplayDTO,
): SavedFiltersAddAction => ({
  type: SavedFiltersAddActionType,
  filter,
});

export interface SavedFiltersUpdateAction {
  type: "update";
  filter: NamedGroopitFilterDisplayDTO;
}
export const SavedFiltersUpdateActionType = "update";
export const createSavedFiltersUpdateAction = (
  filter: NamedGroopitFilterDisplayDTO,
): SavedFiltersUpdateAction => ({
  type: SavedFiltersUpdateActionType,
  filter,
});

export interface SavedFiltersDeleteAction {
  type: "delete";
  filterId: number;
}
export const SavedFiltersDeleteActionType = "delete";
export const createSavedFiltersDeleteAction = (
  filterId: number,
): SavedFiltersDeleteAction => ({
  type: SavedFiltersDeleteActionType,
  filterId,
});

export interface SavedFiltersReplaceAction {
  type: "replace";
  filters: NamedGroopitFilterDisplayDTO[];
}
export const SavedFiltersReplaceActionType = "replace";
export const createSavedFiltersReplaceAction = (
  filters: NamedGroopitFilterDisplayDTO[],
): SavedFiltersReplaceAction => ({
  type: SavedFiltersReplaceActionType,
  filters,
});

export type SavedFiltersActions =
  | SavedFiltersAddAction
  | SavedFiltersUpdateAction
  | SavedFiltersDeleteAction
  | SavedFiltersReplaceAction;
